import { EMAIL_RE } from './identity-ask';

/** Explicit operator opt-in; never infer prefill from a provider or param name. */
export function hasBookingEmailTemplate(value: string): boolean {
  return /\{email\}|%7bemail%7d/i.test(value);
}

/**
 * Substitute only a complete query value, so email can never change the host,
 * path, fragment, or parameter names. Missing/invalid email omits that parameter
 * and lets the scheduler collect it. Plain links keep their original bytes.
 */
export function resolveBookingUrl(value: string | null | undefined, email?: string): string {
  const raw = value?.trim();
  if (!raw) return '';
  try {
    const url = new URL(raw);
    if (url.protocol !== 'https:' || url.username || url.password) return '';
    if (!hasBookingEmailTemplate(raw)) return raw;
    if (hasBookingEmailTemplate(url.origin + url.pathname + url.hash)) return '';

    const address = email?.trim() || '';
    const usableEmail = address.length <= 320 && EMAIL_RE.test(address) ? address : '';
    const params = new URLSearchParams();
    for (const [key, val] of url.searchParams) {
      if (hasBookingEmailTemplate(key)) return '';
      if (hasBookingEmailTemplate(val)) {
        if (val !== '{email}' || url.searchParams.getAll(key).length !== 1) return '';
        if (usableEmail) params.append(key, usableEmail);
      } else {
        params.append(key, val);
      }
    }
    url.search = params.toString();
    return url.toString();
  } catch {
    return '';
  }
}
